import { Box } from '@mui/material';

const DetailContainer = ({ children }) => {
    return (
        <Box sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            columnGap: 2,
            rowGap: 1
        }}>
            {children}
        </Box>
    );
};

export default DetailContainer;